import {Component, OnInit} from '@angular/core';
import {GetSetDataService} from '../../services/get-set-data.service';
import {NgIf} from '@angular/common';
import {MainNavigationComponent} from '../main-navigation/main-navigation.component';
import {LoaderComponent} from '../loader/loader.component';

@Component({
  selector: 'app-left-view',
  templateUrl: './left-view.component.html',
  imports: [
    NgIf,
    MainNavigationComponent,
    LoaderComponent
  ],
  styleUrls: ['./left-view.component.scss']
})
export class LeftViewComponent implements OnInit {

  public mainNavigationData: any;
  public isNavigationNotLoaded = true;

  constructor(private getSetDataService: GetSetDataService) {
  }

  async ngOnInit() {
    this.mainNavigationData = await this.getSetDataService.getCategories();
    this.isNavigationNotLoaded = false;
  }

}
